// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateOverviewHeader":"TaskTemplateBlockOverviewHeader__taskTemplateOverviewHeader__22_l1"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockOverviewHeader/TaskTemplateBlockOverviewHeader.scss
// module id = 1863
// module chunks = 0